/**
 * Page-view tracking hook (afterEach)
 *
 * Fires a "View <page>" analytics event on every route change.
 */

import type { NavigationHookAfter } from 'vue-router';

import trackingEvents from '@/config/trackingEvents';
import { isUnguardedRoute, isUserAuthenticated } from './helpers';

const trackingHook: NavigationHookAfter = (to, from) => {
  // Skip tracking only when an unguarded route is visited without a session.
  // The analytics endpoint requires authentication, and firing here causes a
  // 401 → token refresh → redirect-to-login loop for unauthenticated users.
  if (isUnguardedRoute(to) && !isUserAuthenticated()) return;

  const fromName = String(from.name || 'NULL');
  const toName = String(to.name || 'NULL');

  // Skip tracking for navigation to same route
  if (toName === fromName && to.path === from.path) {
    return;
  }

  trackingEvents.viewPage(toName, fromName, to.params);
};

export default trackingHook;
